import { validateAndFormatNumber, formatBytes } from "../../../utils/format";
import { getColor, colors } from "../../../utils/colors";
import { defaultCellValue } from "../../../utils/enums";

export const getColumns = (props, tViews, isReportView=false) => {
  const tableColumns = [
    {
      prop: "site_name",
      name: tViews('app360siteIDLabel'),
      sortable: true,
      size: 250,
      cellTemplate: (createElement, { model, prop }) => {
        const linkElement = createElement(
          "div",
          {
            class: "table-link",
            onClick: () => {
              const siteId = model && model.site_id ? model.site_id : model;
              props.setSelectedSite(siteId);
            }
          },
          model[prop]
        );
        return createElement("div", { class: "flex-items" }, linkElement);
      }
    },
    {
      prop: "city",
      name: isReportView ? tViews('circuit.ctLocation') : tViews('siteLocation'),
      size: 200,
      sortable: true,
    },
    {
      prop: "vqoe_score",
      name: tViews('applicationTableViewQoE'),
      sortable: true,
      size: 100,
      cellProperties: ({ model, prop }) => {
        return { style: { color: getColor(model[prop], "qoe") } };
      }
    },
    {
      prop: "vqoe_change",
      name: tViews('applicationTableViewQoEChange'),
      sortable: true,
      size: 120,
      cellProperties: ({ model, prop }) => {
        return { style: { color: model[prop] < 0 ? colors.red45 : null } };
      }
    },
    {
      prop: "usage",
      name: tViews('applicationTableViewUsage'),
      size: 120,
      sortable: true,
      order: "desc"
    },
    {
      prop: "packet_loss",
      name: tViews('applicationTableViewLoss'),
      size: 140,
      sortable: true
    },
    {
      prop: "latency",
      name: tViews('latencyInMPS'),
      size: 120,
      sortable: true
    },
    {
      prop: "jitter",
      name: tViews('jitterInMS'),
      size: 120,
      sortable: true
    }
  ];
  return tableColumns;
};

export const setSitesData = data => {
  data.forEach(item => {
    item.checked = false;
    item.usage = formatBytes(item.usage);
    if (item.vqoe_status === "unknown") {
      item.vqoe_score = item.vqoe_change = item.packet_loss = item.latency = item.jitter = defaultCellValue;
    } else {
      item.vqoe_score = validateAndFormatNumber(item.vqoe_score);
      item.vqoe_change = validateAndFormatNumber(item.vqoe_change);
      item.vqoe_change = item.vqoe_change > 0 ? `+${item.vqoe_change}` : item.vqoe_change;
      item.packet_loss = validateAndFormatNumber(item.packet_loss);
      item.latency = validateAndFormatNumber(item.latency);
      item.jitter = validateAndFormatNumber(item.jitter);
    }
  });
};